const ChevronLeft = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const Section = ({ titulo, children }) => (
  <div className="privacidade-secao">
    <h2 className="privacidade-h2">{titulo}</h2>
    {children}
  </div>
);

const P = ({ children }) => (
  <p className="privacidade-p">{children}</p>
);

const Li = ({ children }) => (
  <li className="privacidade-li">{children}</li>
);

export default function PrivacidadePage({ onVoltar }) {
  const dataAtualizacao = '13 de abril de 2026';

  return (
    <div className="privacidade-page">

      {/* Header com voltar */}
      <div className="privacidade-header">
        <button className="btn btn-ghost btn-icon privacidade-voltar" onClick={onVoltar}>
          <ChevronLeft />
        </button>
        <h1 className="privacidade-titulo-page">Política de Privacidade</h1>
      </div>

      <p className="privacidade-atualizacao">
        Última atualização: {dataAtualizacao}
      </p>

      <div className="privacidade-conteudo">

        <Section titulo="1. Quem somos">
          <P>
            O <strong>Clube do Eu</strong> é um aplicativo de journaling e desenvolvimento pessoal
            desenvolvido e operado por Clube do Eu. Nosso objetivo é apoiar sua jornada de
            autoconhecimento por meio de reflexões diárias, acompanhamento de humor e práticas
            de bem-estar.
          </P>
          <P>
            Para dúvidas sobre esta política ou para exercer seus direitos, entre em contato
            pelo e-mail: <strong>contato@oclubedoeu.com.br</strong>
          </P>
        </Section>

        <Section titulo="2. Quais dados coletamos">
          <P>Coletamos os seguintes dados quando você usa o Clube do Eu:</P>
          <ul className="privacidade-lista">
            <Li><strong>Dados de cadastro:</strong> endereço de e-mail e nome de exibição.</Li>
            <Li><strong>Dados de humor:</strong> registro diário de como você se sente (escala de 1 a 5). Estes são considerados <em>dados sensíveis</em> pela LGPD.</Li>
            <Li><strong>Reflexões pessoais:</strong> textos que você escreve no diário. Também são dados sensíveis.</Li>
            <Li><strong>Dados de progresso:</strong> sequência de dias (streak), conquistas (badges), desafios participados e livros registrados.</Li>
            <Li><strong>Dados técnicos:</strong> endereço IP, tipo de dispositivo e navegador, coletados automaticamente para funcionamento do serviço e segurança.</Li>
            <Li><strong>Dados de uso:</strong> páginas acessadas e interações no app, coletados via Google Analytics.</Li>
          </ul>
        </Section>

        <Section titulo="3. Para que usamos seus dados">
          <ul className="privacidade-lista">
            <Li>Fornecer e personalizar as funcionalidades do app (journaling, streak, desafios).</Li>
            <Li>Exibir seu histórico e estatísticas de progresso.</Li>
            <Li>Enviar notificações de lembrete diário (somente se você ativar).</Li>
            <Li>Melhorar o produto com base em métricas agregadas de uso.</Li>
            <Li>Exibir publicidade relevante nas nossas redes sociais (via Meta Pixel).</Li>
            <Li>Garantir a segurança da sua conta e prevenir abusos.</Li>
          </ul>
        </Section>

        <Section titulo="4. Terceiros que recebem seus dados">
          <P>Compartilhamos seus dados com os seguintes parceiros, somente na medida necessária:</P>
          <ul className="privacidade-lista">
            <Li>
              <strong>Supabase Inc.</strong> — infraestrutura de banco de dados e autenticação.
              Seus dados são armazenados em servidores nos EUA com proteções contratuais adequadas
              (Standard Contractual Clauses). Política:{' '}
              <a href="https://supabase.com/privacy" target="_blank" rel="noopener noreferrer" className="privacidade-link">
                supabase.com/privacy
              </a>
            </Li>
            <Li>
              <strong>Meta Platforms (Facebook/Instagram)</strong> — usamos o Meta Pixel para
              medir o desempenho de anúncios. Isso pode associar sua visita a campanhas
              publicitárias. Política:{' '}
              <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer" className="privacidade-link">
                facebook.com/privacy/policy
              </a>
            </Li>
            <Li>
              <strong>Google LLC (Google Analytics)</strong> — usamos o Google Analytics para
              analisar como o app é utilizado de forma agregada. Os dados são anonimizados
              quando possível. Política:{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="privacidade-link">
                policies.google.com/privacy
              </a>
            </Li>
          </ul>
          <P>
            Não vendemos, alugamos nem comercializamos seus dados pessoais com terceiros.
          </P>
        </Section>

        <Section titulo="5. Por quanto tempo guardamos seus dados">
          <P>
            Seus dados são mantidos enquanto sua conta estiver ativa. Se você excluir sua
            conta, todos os dados pessoais são removidos permanentemente dos nossos sistemas
            em até 30 dias, exceto os que precisamos manter por obrigação legal.
          </P>
        </Section>

        <Section titulo="6. Seus direitos (LGPD — Art. 18)">
          <P>Como titular de dados, você tem os seguintes direitos:</P>
          <ul className="privacidade-lista">
            <Li><strong>Acesso:</strong> saber quais dados temos sobre você.</Li>
            <Li><strong>Correção:</strong> corrigir dados incompletos ou inexatos.</Li>
            <Li><strong>Exclusão:</strong> solicitar a remoção dos seus dados — disponível diretamente no app, em Perfil → Meus dados → Excluir conta.</Li>
            <Li><strong>Portabilidade:</strong> receber seus dados em formato legível.</Li>
            <Li><strong>Revogação do consentimento:</strong> você pode revogar seu consentimento a qualquer momento, o que implicará na exclusão da sua conta.</Li>
            <Li><strong>Informação:</strong> saber com quais terceiros compartilhamos seus dados.</Li>
          </ul>
          <P>
            Para exercer qualquer um desses direitos, entre em contato pelo e-mail{' '}
            <strong>contato@oclubedoeu.com.br</strong> ou use as ferramentas disponíveis
            diretamente no app.
          </P>
        </Section>

        <Section titulo="7. Base legal do tratamento">
          <P>
            O tratamento dos seus dados é realizado com base no seu{' '}
            <strong>consentimento</strong> (Art. 7º, inciso I da LGPD), fornecido no momento
            em que você aceitou esta política ao criar sua conta ou ao continuar usando o app
            após a sua publicação.
          </P>
          <P>
            Dados de humor e reflexões pessoais — classificados como dados sensíveis pela
            LGPD (Art. 11) — são tratados exclusivamente com base no seu consentimento
            específico, livre e informado.
          </P>
        </Section>

        <Section titulo="8. Segurança">
          <P>
            Adotamos medidas técnicas e organizacionais para proteger seus dados, incluindo
            criptografia em trânsito (HTTPS), controle de acesso e autenticação segura.
            Nenhum sistema é 100% inviolável; em caso de incidente de segurança que afete
            seus dados, você será notificado conforme exigido pela LGPD.
          </P>
        </Section>

        <Section titulo="9. Crianças e adolescentes">
          <P>
            O Clube do Eu não é destinado a menores de 18 anos. Não coletamos intencionalmente
            dados de menores. Se tomarmos conhecimento de que um menor forneceu dados,
            removeremos as informações imediatamente.
          </P>
        </Section>

        <Section titulo="10. Alterações nesta política">
          <P>
            Podemos atualizar esta política periodicamente. Quando fizermos alterações
            relevantes, notificaremos você pelo app ou por e-mail. A data de última
            atualização sempre constará no topo desta página.
          </P>
        </Section>

        <Section titulo="11. Contato e DPO">
          <P>
            Para questões relacionadas à privacidade dos seus dados:
          </P>
          <P>
            <strong>E-mail:</strong> contato@oclubedoeu.com.br
          </P>
          <P>
            Você também pode registrar uma reclamação junto à{' '}
            <strong>Autoridade Nacional de Proteção de Dados (ANPD)</strong> em{' '}
            <a href="https://www.gov.br/anpd" target="_blank" rel="noopener noreferrer" className="privacidade-link">
              gov.br/anpd
            </a>.
          </P>
        </Section>

      </div>
    </div>
  );
}
